import { useTranslation } from "react-i18next";
import NavBar from "../components/NavBar";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import Footer from "../components/Footer";

export default function Abb() {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper">      
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        <div className="big-title">ABB</div>
        <img
          src="/projects/abb.webp"
          alt="ABB"
          className="project-image"
        />
        <div className="porfolio-project-text-wrapper">
          <p className="section-content-unbounded">
            {t("abbDescriptionShort")}
          </p>

          <p className="section-content-unbounded">
            {t("abbDescriptionLong")}
          </p>
        </div>
        <div className="cta-button-secondary-wrapper-bottom">
          <Link 
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("abbPage")}
          >
            {t("ctaBookCall")}
          </Link>
        </div>        
        <Footer /> 
      </div>              
    </div>
  );
}
